import request from "../utils/request";

export function getAnalyticsAccounts() {
  return request({ url: "/getAnalyticsAccounts", method: "get" });
}

export function getAnalyticsInfo({ activeDays = 30, accountId = "" } = {}) {
  const query = new URLSearchParams({ activeDays: String(activeDays) });
  if (accountId) query.set("accountId", accountId);
  return request({ url: `/getAnalyticsInfo?${query}`, method: "get" });
}

export function getJMasterAll() {
  return request({
    url: "/getJMasterAll",
    method: "get",
  });
}

export function login(query) {
  return request({
    url: "/login",
    method: "post",
    data: query,
    skipAuth: true,
  });
}

export function updateUserFromApproval(query) {
  return request({
    url: "/updateUserFromApproval",
    method: "post",
    data: query,
  });
}

export function updateUserFromWeb(query) {
  return request({
    url: "/updateUserFromWeb",
    method: "post",
    data: query,
  });
}

export function register(data) {
  return request({
    url: "/register",
    method: "post",
    data: data,
  });
}

export function getUser(userId) {
  return request({
    url: "/getUser/" + userId,
    method: "get",
  });
}

export function getAllProInfoByAuthFlg(authFlg) {
  return request({
    url: "/getAllProInfoByAuthFlg/" + authFlg,
    method: "get",
  });
}

export function verify(token) {
  return request({
    url: "/verify/" + token,
    method: "get",
    skipAuth: true,
  });
}

export function getDaikaiParticipants() {
  return request({
    url: "/getDaikaiParticipants",
    method: "get",
  });
}
export function getUserFans() {
  return request({
    url: "/getUserFans",
    method: "get",
  });
}
export function getWebUserSchedule() {
  return request({
    url: "/getWebUserSchedule",
    method: "get",
  });
}
// 推しごとカレンダー、雀活マスター利用人数を統計
export function getOshicalAndJankatsumasterUserCnt() {
  return request({
    url: "/getOshicalAndJankatsumasterUserCnt",
    method: "get",
  });
}

// 広告集計
export function getADDisplayInfoSUMList() {
  return request({
    url: "/getADDisplayInfoSUMList",
    method: "get",
  });
}
// 広告一覧
export function getADDisplayInfoList() {
  return request({
    url: "/getADDisplayInfoList",
    method: "get",
  });
}

// 広告ダッシュボード(時間単位)
export function getADPerTimeInfoList(query, signal) {
  return request({
    url: "/getADPerTimeInfoList",
    method: "post",
    data: query,
    signal,
  });
}
// 広告ダッシュボード(日単位)
export function getADPerDayInfoList(query, signal) {
  return request({
    url: "/getADPerDayInfoList",
    method: "post",
    data: query,
    signal,
  });
}
// ゲスト(日単位)
export function getGuestPerDayInfoList(query, signal) {
  return request({
    url: "/getGuestPerDayInfoList",
    method: "post",
    data: query,
    signal,
  });
}
// 広告ダッシュボード(週単位)
export function getADPerWeekInfoList(query, signal) {
  return request({
    url: "/getADPerWeekInfoList",
    method: "post",
    data: query,
    signal,
  });
}
// 広告集計情報
export function getSumADInfo(query, signal) {
  return request({
    url: "/getSumADInfo",
    method: "post",
    data: query,
    signal,
  });
}

// 広告集計情報(指定期間以降の合計)
export function getSumADInfoFrom(query, signal) {
  return request({
    url: "/getSumADInfoFrom",
    method: "post",
    data: { ...query, startDate: "2026/01/01 00:00:00" },
    signal,
  });
}

// 広告集計情報
export function getAllADListForUser(query) {
  return request({
    url: "/getAllADListForUser",
    method: "post",
    data: query,
  });
}

// すべての広告集計情報
export function getADDailyImpressions(query, signal) {
  return request({
    url: "/getSumAllADInfoFrom",
    method: "post",
    data: query,
    signal,
  });
}

// 大バナー画像アップロード
export function uploadBannerImage(formData) {
  return request({
    url: "/banner/uploadImage/banner",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// バナー画像アップロード
export function uploadSmallBannerImage(formData) {
  return request({
    url: "/banner/uploadImage/small/banner",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 大会画像アップロード(管理画面用)
export function uploadDaikaiImage(formData) {
  return request({
    url: "/uploadImageDaikai",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// プレビューバナーHTML公開
export function previewPublishBannerHtml(data) {
  return request({
    url: "/banner/preview/publish",
    method: "post",
    data: data,
  });
}

// バナーHTML公開
export function publishBannerHtml(data) {
  return request({
    url: "/banner/publish",
    method: "post",
    data: data,
  });
}

// バナーHTML取得
export function getBannerHtml() {
  return request({
    url: "/banner/getHtml",
    method: "get",
  });
}

// プレビュー小バナーHTML公開
export function previewPublishSmallBannerHtml(data) {
  return request({
    url: "/banner/preview/small/publish",
    method: "post",
    data: data,
  });
}

// 小バナーHTML公開
export function publishSmallBannerHtml(data) {
  return request({
    url: "/banner/small/publish",
    method: "post",
    data: data,
  });
}

// 小バナーHTML取得
export function getSmallBannerHtml() {
  return request({
    url: "/banner/small/getHtml",
    method: "get",
  });
}

// データ移行
export function doDataIko(data) {
  return request({
    url: "/doDataIko",
    method: "get",
    params: data,
  });
}

// 大会一覧取得(管理画面用)
export function getDaikaiEventList() {
  return request({
    url: "/getDaikaiEventList",
    method: "get",
  });
}

// 大会一件取得(管理画面用)
export function getDaikaiEvent(id) {
  return request({
    url: "/getDaikaiEvent/" + id,
    method: "get",
  });
}

// 大会申込(公開用:URLから直接申込受付)
export function upsertJDaikaiParticipantsFromUnickName(data) {
  return request({
    url: "/upsertJDaikaiParticipantsFromUnickName",
    method: "post",
    data: data,
    skipAuth: true,
  });
}

// 大会登録更新(管理画面用)
export function saveDaikaiEvent(data) {
  return request({
    url: "/saveDaikaiEvent",
    method: "post",
    data: data,
  });
}

// 大会削除(管理画面用)
export function deleteDaikaiEvent(id) {
  return request({
    url: "/deleteDaikaiEvent",
    method: "post",
    data: { id: id },
  });
}

// Proおすすめ候補者一覧取得（管理画面用）
export function getProRecommendationCandidates(params = {}) {
  const query = params.keyword
    ? `?keyword=${encodeURIComponent(params.keyword)}`
    : "";
  return request({
    url: `/getProRecommendationCandidates${query}`,
    method: "get",
  });
}

// 候補者登録用ユーザー検索（管理画面用）
export function searchProRecommendationUsers(keyword = "", page = 1) {
  const query = new URLSearchParams({ keyword, page: String(page) });
  return request({
    url: `/searchProRecommendationUsers?${query}`,
    method: "get",
  });
}

// Proおすすめ候補者一件取得（管理画面用）
export function getProRecommendationCandidate(id) {
  return request({
    url: "/getProRecommendationCandidate/" + encodeURIComponent(id),
    method: "get",
  });
}

// Proおすすめ候補者登録更新（管理画面用）
export function saveProRecommendationCandidate(data) {
  return request({
    url: "/saveProRecommendationCandidate",
    method: "post",
    data: data,
  });
}

// Proおすすめ候補者削除（管理画面用）
export function deleteProRecommendationCandidate(id) {
  return request({
    url: "/deleteProRecommendationCandidate",
    method: "post",
    data: { id: id },
  });
}
